export const socialLoginErrorTypes = {
	CUSTOMER_WITH_LOGIN_EXIST: 'alreadyExist'
};